import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from '../api/userAuth.api';

const UserAuthContext = createContext(null);

export const UserAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('userToken'));
  const [loading, setLoading] = useState(!!localStorage.getItem('userToken'));

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    getMe()
      .then((u) => setUser(u))
      .catch(() => { localStorage.removeItem('userToken'); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const login = useCallback((tokenStr, userData) => {
    localStorage.setItem('userToken', tokenStr);
    setToken(tokenStr);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('userToken');
    setToken(null);
    setUser(null);
  }, []);

  return (
    <UserAuthContext.Provider value={{ user, token, loading, login, logout, isAuthenticated: !!token }}>
      {children}
    </UserAuthContext.Provider>
  );
};

export const useUserAuth = () => {
  const ctx = useContext(UserAuthContext);
  if (!ctx) throw new Error('useUserAuth must be used within UserAuthProvider');
  return ctx;
};
